import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { FormAddOrderComponent } from '../../../pages/orders/form-add-order/form-add-order.component';

@Injectable({
  providedIn: 'root',
})
export class ExtrasService {
  constructor(private translate: TranslateService) {}

  async traducirError2(errores: any) {
    const error = errores;
    var message = '';
    if (typeof error == 'object' && !Array.isArray(error)) {
      for (const key in error) {
        if (typeof error[key] == 'object' && !Array.isArray(error[key])) {
          const keyTranslate = await firstValueFrom(this.translate
            .get('swal_messages.inputs.' + key));
          let valueTranslate = error[key].msg;
          let params = error[key];
          delete params.msg;
          params.campo = keyTranslate;

          valueTranslate = await firstValueFrom(this.translate
            .get(valueTranslate, params));
          if (typeof valueTranslate === 'string') {
            message += '- ' + valueTranslate + '\n';
          }
        }
      }
    }

    if (typeof error == 'object' && Array.isArray(error)) {
      ///array
      for (let i = 0; i < error.length; i++) {
        const item = error[i];
        const aux = await firstValueFrom(this.translate
          .get('swal_messages.inputs.' + item));
        message += '- ' + aux + '\n';
      }
    }

    return message;
  }

  async traducirError(errores: any) {
    const error = errores;
    let message = '';
    for (const key in error) {
      if (!Object.hasOwnProperty.call(error, key)) continue;

      let keyTranslate = await firstValueFrom(this.translate
        .get('swal_messages.inputs.' + key));
      // Fallback: if prefixed key (e.g. client.email) wasn't found, try without prefix (e.g. email)
      if (keyTranslate === 'swal_messages.inputs.' + key && key.includes('.')) {
        const unprefixed = key.substring(key.lastIndexOf('.') + 1);
        keyTranslate = await firstValueFrom(this.translate
          .get('swal_messages.inputs.' + unprefixed));
      }

      let valueTranslate: any = '';
      let params: any = '';

      if (Array.isArray(error[key])) {
        const translatedErrors = await Promise.all(
          error[key].map(async (err: any) => {
            // Handle items that are strings instead of objects
            if (typeof err === 'string') {
              const translated = await firstValueFrom(this.translate.get(err));
              return translated !== err ? translated : err;
            }
            let localParams = { ...err };
            const localValueTranslate = err['msg'];
            if (!localValueTranslate) {
              return err['translate'] || JSON.stringify(err);
            }
            delete localParams.msg;
            delete localParams.translate;
            localParams.campo = keyTranslate;

            let translatedMessage = await firstValueFrom(this.translate
              .get(localValueTranslate, localParams));

            // Fallback: si ngx-translate devuelve la clave sin traducir, usar campo translate del backend
            if (translatedMessage === localValueTranslate && err['translate']) {
              translatedMessage = err['translate'];
            }

            return translatedMessage;
          })
        );
        valueTranslate = translatedErrors.join('\n- ');
      } else if (typeof error[key] == 'object' && error[key] !== null) {
        valueTranslate = error[key].msg;
        params = error[key];
        delete params.msg;
        params.campo = keyTranslate;
      }

      if (!Array.isArray(error[key])) {
        if (valueTranslate) {
          valueTranslate = await firstValueFrom(this.translate
            .get(valueTranslate, params));
        }
      }

      if (typeof valueTranslate === 'string' && valueTranslate) {
        message += '- ' + valueTranslate + '\n';
      }
    }
    return message;
  }
}
